import { render, staticRenderFns } from "./knowledgebase.vue?vue&type=template&id=6a180ad2&"
import script from "./knowledgebase.vue?vue&type=script&lang=js&"
export * from "./knowledgebase.vue?vue&type=script&lang=js&"
import style0 from "./knowledgebase.vue?vue&type=style&index=0&id=6a180ad2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports